
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { GoodRoadItemMixin } from './good-road-item-mixin'
import GoodRoadTimerIcon from './good-road-timer-icon.vue'

@Options({
    name: 'd-good-road-item',
    components: {
        GoodRoadTimerIcon
    }
})
export default class DGoodRoadItem extends Mixins(GoodRoadItemMixin) {}
